import { createContext, type RefCallback } from 'react'

export const InternalPageHeaderContext = createContext<{
  baseRoot: HTMLDivElement | null
  setBaseRoot: RefCallback<HTMLDivElement>
  homeRoot: HTMLDivElement | null
  setHomeRoot: RefCallback<HTMLDivElement>
  tabsRoot: HTMLDivElement | null
  setTabsRoot: RefCallback<HTMLDivElement>
  toolsRoot: HTMLDivElement | null
  setToolsRoot: RefCallback<HTMLDivElement>
}>({
  baseRoot: null,
  setBaseRoot: () => {},
  homeRoot: null,
  setHomeRoot: () => {},
  tabsRoot: null,
  setTabsRoot: () => {},
  toolsRoot: null,
  setToolsRoot: () => {},
})
